/* eslint-disable eol-last */
import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import provider from './provider/provider'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    state: {
        baseApi: 'https://www.ikolilu.com/api/v1.0/ik_providers_.php'
    },

    mutations: {},

    actions: {},

    modules: {
        provider
    },

    plugins: [
        createPersistedState()
    ]
})